<template>
  <section class="mt-14 min-h-screen bg-subtleGray">
    <div class="mt-6 w-full max-w-1xl mx-auto p-3 py-20 md:py-10 md:p-6">
      <div class="w-full flex flex-col items-center justify-center">
        <!-- badge -->
        <span
          class="px-3 py-1 rounded-md bg-brandPurple text-white text-sm font-medium"
        >
          General License
        </span>
        <h1
          class="mt-3 text-3xl md:text-5xl max-w-2xl text-center font-bold text-gray-800"
        >
          Making It Easy To License Your Creative Project.
        </h1>
        <h3 class="mt-4 text-sm text-center text-gray-600">
          Build great features with
          <span class="underline">one simple commercial license</span>
          possibilities.
        </h3>
        <!-- end of badge -->
      </div>
    </div>

    <!-- 2nd section -->
    <div class="my-10 py-20 md:py-0 pattern">
      <div
        class="relative z-10 mx-auto sm:flex sm:items-center justify-center px-6 md:px-12"
      >
        <span class="inline relative cursor-pointer mr-10 2xl:mr-20">
          <div class="absolute z-50 w-full flex items-end justify-end inset-0">
            <svg
              class="w-12 h-12 mr-3 text-white"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z"
                clip-rule="evenodd"
              />
            </svg>
          </div>
          <div class="relative inline ">
            <a href="#">
              <img
                class="w-96 h-60 sm:-my-4 -mt-16 mx-auto sm:mx-0 shadow-xl rounded-lg relative"
                src="https://images.unsplash.com/photo-1542365775-b0037a7c904f?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=667&q=80"
                alt="A thumbnail preview of a demo video"
              />
            </a>
          </div>
        </span>
        <div class=" mt-10 md:mt-0 flex flex-col items-center justify-center">
          <!-- badge -->
          <span
            class="px-3 py-1 rounded-md bg-gray-100 text-gray-800 text-sm font-medium"
          >
            The Key Points
          </span>
          <h1
            class="mt-3 text-2xl md:text-3xl 2xl:text-4xl max-w-md text-center font-bold text-gray-800"
          >
            Start Doing Great Things!
          </h1>
          <h3 class="mt-3 text-sm text-center text-gray-700">
            Together We Can Bring More Creativity into the World.
          </h3>
          <!-- end of badge -->
        </div>
      </div>
    </div>
    <!-- end of 2nd section -->

    <!-- 3rd section -->
    <div class="container px-5 pt-20 pb-10 mx-auto">
      <div
        class="flex items-center lg:w-3/5 mx-auto border-b pb-10 mb-10 border-gray-200 sm:flex-row flex-col"
      >
        <div
          class="sm:w-32 sm:h-32 h-20 w-20 sm:mr-10 inline-flex items-center justify-center rounded-full bg-indigo-100 text-indigo-500 flex-shrink-0"
        >
          <svg
            class="w-20 h-20"
            aria-hidden="true"
            focusable="false"
            width="1em"
            height="1em"
            style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);"
            preserveAspectRatio="xMidYMid meet"
            viewBox="0 0 20 20"
          >
            <g fill="none">
              <path
                d="M4 3a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h7.5v-.671a4.514 4.514 0 0 1-.242-.329H4a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v2.468c.364.18.7.41 1 .678V5a2 2 0 0 0-2-2H4z"
                fill="currentColor"
              />
              <path
                d="M18.5 11.5a3.5 3.5 0 1 1-7 0a3.5 3.5 0 0 1 7 0z"
                fill="currentColor"
              />
              <path
                d="M15 16c.925 0 1.785-.28 2.5-.758V18a.5.5 0 0 1-.8.4l-1.4-1.05a.5.5 0 0 0-.6 0l-1.4 1.05a.5.5 0 0 1-.8-.4v-2.758A4.478 4.478 0 0 0 15 16z"
                fill="currentColor"
              />
              <path
                d="M5 6.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5z"
                fill="currentColor"
              />
              <path
                d="M5.5 11a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4z"
                fill="currentColor"
              />
            </g>
            <rect x="0" y="0" width="20" height="20" fill="rgba(0, 0, 0, 0)" />
          </svg>
        </div>

        <div class="flex-grow sm:text-left text-center mt-6 sm:mt-0">
          <h2 class="text-gray-900 text-lg title-font font-semibold mb-2">
            One simple commercial license
          </h2>
          <p class="leading-relaxed text-base">
            All of the assets you use in projects are covered by our simple,
            full usage license forever. We grant you the license to use our
            assets for personal and broad business projects.
          </p>
        </div>
      </div>

      <div
        class="flex items-center lg:w-3/5 mx-auto border-b pb-10 mb-10 border-gray-200 sm:flex-row flex-col"
      >
        <div class="flex-grow sm:text-left text-center mt-6 sm:mt-0">
          <h2 class="text-gray-900 text-lg title-font font-semibold mb-2">
            Make a download for a project
          </h2>
          <p class="leading-relaxed text-base">
            You may use the license granted by us for one project only, If you
            want to use the same item in a new project you need to redownload
            it. Or Visit your downloads and add license it again for different
            end-use.
          </p>
        </div>
        <div
          class="sm:w-32 sm:order-none order-first sm:h-32 h-20 w-20 sm:ml-10 inline-flex items-center justify-center rounded-full bg-indigo-100 text-indigo-500 flex-shrink-0"
        >
          <svg
            class="w-20 h-20"
            aria-hidden="true"
            focusable="false"
            width="1em"
            height="1em"
            style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);"
            preserveAspectRatio="xMidYMid meet"
            viewBox="0 0 24 24"
          >
            <g fill="none">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M2 6a3 3 0 0 1 3-3h3.93a3 3 0 0 1 2.496 1.336l.812 1.219A1 1 0 0 0 13.07 6H19a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V6zm11 5a1 1 0 1 0-2 0v3.586l-1.293-1.293a1 1 0 0 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0l3-3a1 1 0 0 0-1.414-1.414L13 14.586V11z"
                fill="currentColor"
              />
            </g>
            <rect x="0" y="0" width="24" height="24" fill="rgba(0, 0, 0, 0)" />
          </svg>
        </div>
      </div>

      <div
        class="flex items-center lg:w-3/5 mx-auto border-b pb-10 mb-10 border-gray-200 sm:flex-row flex-col"
      >
        <div
          class="sm:w-32 sm:h-32 h-20 w-20 sm:mr-10 inline-flex items-center justify-center rounded-full bg-indigo-100 text-indigo-500 flex-shrink-0"
        >
          <svg
            class="w-20 h-20"
            aria-hidden="true"
            focusable="false"
            width="1em"
            height="1em"
            style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);"
            preserveAspectRatio="xMidYMid meet"
            viewBox="0 0 24 24"
          >
            <path
              d="M19 11h-6V8h6a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H5L2 5l3 3h6v3H5a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h6v5h2v-5h6l3-3l-3-3z"
              fill="currentColor"
            />
            <rect x="0" y="0" width="24" height="24" fill="rgba(0, 0, 0, 0)" />
          </svg>
        </div>
        <div class="flex-grow sm:text-left text-center mt-6 sm:mt-0">
          <h2 class="text-gray-900 text-lg title-font font-semibold mb-2">
            Short guidelines for our restrictions.
          </h2>
          <p class="leading-relaxed text-base">
            Further, you can find about certain restrictions applied to the use
            of our items:
          </p>
          <ul class="ml-3 mt-3 leading-relaxed text-base list-inside list-disc">
            <li>You can't re-sell, or re-distribute items</li>
            <li>You can't use items in on-demand services</li>
            <li>You can't use music items in a Broadcast presentation</li>
          </ul>
        </div>
      </div>

      <div
        class="flex items-center lg:w-3/5 mx-auto border-b pb-10 mb-10 border-gray-200 sm:flex-row flex-col"
      >
        <div class="flex-grow sm:text-left text-center mt-6 sm:mt-0">
          <h2 class="text-gray-900 text-lg title-font font-semibold mb-2">
            Support with our licensing, even if you unsubscribe.
          </h2>
          <p class="leading-relaxed text-base">
            If you unsubscribe, you can no longer use Motion Ridge items. Still,
            the license will remain valid for all products created during the
            active period of your subscription.
          </p>
        </div>
        <div
          class="sm:w-32 sm:order-none order-first sm:h-32 h-20 w-20 sm:ml-10 inline-flex items-center justify-center rounded-full bg-indigo-100 text-indigo-500 flex-shrink-0"
        >
          <svg
            class="w-20 h-20"
            aria-hidden="true"
            focusable="false"
            width="1em"
            height="1em"
            style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);"
            preserveAspectRatio="xMidYMid meet"
            viewBox="0 0 24 24"
          >
            <path
              d="M21.2 10.95L12 23L2.78 10.96l.09-.08c.21-.21.46-.38.71-.52l7.15 9.33L8.58 13l.66-1.19L12 20.38l2.73-8.58l.67 1.2l-2.13 6.69l7.14-9.34c.25.15.49.29.69.5l.1.1M5 9c1.5 0 2.81.86 3.5 2.1A3.97 3.97 0 0 1 12 9c1.5 0 2.8.85 3.5 2.09A3.93 3.93 0 0 1 19 9c1.09 0 2.09.42 2.81 1.14C20.94 5.5 16.88 2 12 2c-4.91 0-8.97 3.5-9.84 8.17C2.89 9.45 3.89 9 5 9z"
              fill="currentColor"
            />
            <rect x="0" y="0" width="24" height="24" fill="rgba(0, 0, 0, 0)" />
          </svg>
        </div>
      </div>
    </div>
    <!-- end of 3rd section -->

    <!-- 4th section -->
    <div class="mb-10 pb-20 w-full container mx-auto">
      <div class="w-full flex flex-col items-center justify-center">
        <!-- badge -->
        <span
          class="px-3 py-1 rounded-md bg-brandPurple text-white text-sm font-medium"
        >
          Its really that simple
        </span>
        <h1
          class="mt-3 text-2xl md:text-3xl 2xl:text-4xl max-w-md text-center font-bold text-gray-800"
        >
          Specific Uses
        </h1>
      </div>

      <div
        class="mt-10 w-full flex md:flex-row flex-col items-start justify-center gap-10"
      >
        <div
          class=" w-full md:max-w-sm flex items-center justify-center flex-col"
        >
          <h1 class="text-base md:text-lg text-gray-800 font-bold text-center">
            Editorial Use
          </h1>
          <div class="h-1 mt-1 w-10 rounded-full bg-brandPurple"></div>
          <p class="mt-5 text-sm text-gray-700 text-left">
            Some stock footage and images are labeled for “Editorial Use Only”
            when they contain people, locations, or trademarks without a signed
            release for commercial use.
          </p>
          <p class="mt-5 text-sm text-gray-700 text-left">
            For more information on Editorial Use restrictions, please visit our
            Help Center.
          </p>
        </div>
        <div
          class=" w-full md:max-w-sm flex items-center justify-center flex-col"
        >
          <h1 class="text-base md:text-lg text-gray-800 font-bold text-center">
            P.R.O and Content Id
          </h1>
          <div class="h-1 mt-1 w-10 rounded-full bg-brandPurple"></div>
          <p class="mt-5 text-sm text-gray-700 text-left">
            While the music tracks in our Marketplace are royalty-free, meaning
            that we do not collect any royalties on behalf of the contributors,
            these contributors may register their music with a performance
            rights organization (P.R.O.) or Content ID outside of Motion Ridge.
          </p>
          <p class="mt-5 text-sm text-gray-700 text-left">
            P.R.O. affiliated music tracks require some additional steps for
            reporting and Content ID ensures that only licensed use is
            permitted. To learn how to work with P.R.O. music tracks and cue
            sheet reporting as well as more information about how to use Content
            ID registered tracks, please visit our Help Center.
          </p>
        </div>
      </div>
    </div>
    <!-- end of 4th section -->

    <!-- 5th section -->
    <div class="w-full pattern2 py-10 px-3 md-px-6 2xl:px-0">
      <div class="w-full container mx-auto">
        <div class="w-full flex flex-col items-center justify-center">
          <h1 class="mt-3 text-xl md:text-5xl text-center font-bold text-white">
            Simple Licensing for every project
          </h1>
          <h3 class="mt-2 text-sm text-center text-gray-200">
            Unlimited Download Video Templates, Effects, Music, Footage And
            More.
          </h3>

          <div
            class="mt-5 flex flex-col md:flex-row gap-5 items-center jusify-center"
          >
            <router-link
              v-if="!getCurrentUser"
              to="/register"
              class="px-4 py-1 rounded-md bg-buttonColor border border-transparent text-white text-sm font-medium whitespace-nowrap focus:outline-none"
            >
              Join Free
            </router-link>
            <router-link
              to="/pricing"
              class="px-4 py-1 rounded-md bg-transparent border border-buttonColor text-white text-sm font-medium whitespace-nowrap focus:outline-none"
            >
              View Pricing
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <!-- end of 5th section -->
  </section>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "License",
  components: {},
  computed: {
    ...mapGetters(["getCurrentUser"]),
  },
};
</script>
<style scoped>
.image-container {
  position: relative;
  width: 100%;
  padding-top: 56.25%; /* 16:9 Aspect Ratio */
}

.pattern {
  background-color: #7631ff1f;
  background-image: url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM12 86c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm28-65c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm23-11c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-6 60c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm29 22c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zM32 63c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm57-13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-9-21c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM60 91c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM35 41c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM12 60c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z' fill='%237631ff' fill-opacity='0.2' fill-rule='evenodd'/%3E%3C/svg%3E");
}

.pattern2 {
  background-color: #181818;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100%25'%3E%3Cdefs%3E%3ClinearGradient id='a' gradientUnits='userSpaceOnUse' x1='0' x2='0' y1='0' y2='100%25' gradientTransform='rotate(0,842,429)'%3E%3Cstop offset='0' stop-color='%23181818'/%3E%3Cstop offset='1' stop-color='%23404040'/%3E%3C/linearGradient%3E%3Cpattern patternUnits='userSpaceOnUse' id='b' width='436' height='363.3' x='0' y='0' viewBox='0 0 1080 900'%3E%3Cg fill-opacity='0.1'%3E%3Cpolygon fill='%23444' points='90 150 0 300 180 300'/%3E%3Cpolygon points='90 150 180 0 0 0'/%3E%3Cpolygon fill='%23AAA' points='270 150 360 0 180 0'/%3E%3Cpolygon fill='%23DDD' points='450 150 360 300 540 300'/%3E%3Cpolygon fill='%23999' points='450 150 540 0 360 0'/%3E%3Cpolygon points='630 150 540 300 720 300'/%3E%3Cpolygon fill='%23DDD' points='630 150 720 0 540 0'/%3E%3Cpolygon fill='%23444' points='810 150 720 300 900 300'/%3E%3Cpolygon fill='%23FFF' points='810 150 900 0 720 0'/%3E%3Cpolygon fill='%23DDD' points='990 150 900 300 1080 300'/%3E%3Cpolygon fill='%23444' points='990 150 1080 0 900 0'/%3E%3Cpolygon fill='%23DDD' points='90 450 0 600 180 600'/%3E%3Cpolygon points='90 450 180 300 0 300'/%3E%3Cpolygon fill='%23666' points='270 450 180 600 360 600'/%3E%3Cpolygon fill='%23AAA' points='270 450 360 300 180 300'/%3E%3Cpolygon fill='%23DDD' points='450 450 360 600 540 600'/%3E%3Cpolygon fill='%23999' points='450 450 540 300 360 300'/%3E%3Cpolygon fill='%23999' points='630 450 540 600 720 600'/%3E%3Cpolygon fill='%23FFF' points='630 450 720 300 540 300'/%3E%3Cpolygon points='810 450 720 600 900 600'/%3E%3Cpolygon fill='%23DDD' points='810 450 900 300 720 300'/%3E%3Cpolygon fill='%23AAA' points='990 450 900 600 1080 600'/%3E%3Cpolygon fill='%23444' points='990 450 1080 300 900 300'/%3E%3Cpolygon fill='%23222' points='90 750 0 900 180 900'/%3E%3Cpolygon points='270 750 180 900 360 900'/%3E%3Cpolygon fill='%23DDD' points='270 750 360 600 180 600'/%3E%3Cpolygon points='450 750 540 600 360 600'/%3E%3Cpolygon points='630 750 540 900 720 900'/%3E%3Cpolygon fill='%23444' points='630 750 720 600 540 600'/%3E%3Cpolygon fill='%23AAA' points='810 750 720 900 900 900'/%3E%3Cpolygon fill='%23666' points='810 750 900 600 720 600'/%3E%3Cpolygon fill='%23999' points='990 750 900 900 1080 900'/%3E%3Cpolygon fill='%23999' points='180 0 90 150 270 150'/%3E%3Cpolygon fill='%23444' points='360 0 270 150 450 150'/%3E%3Cpolygon fill='%23FFF' points='540 0 450 150 630 150'/%3E%3Cpolygon points='900 0 810 150 990 150'/%3E%3Cpolygon fill='%23222' points='0 300 -90 450 90 450'/%3E%3Cpolygon fill='%23FFF' points='0 300 90 150 -90 150'/%3E%3Cpolygon fill='%23FFF' points='180 300 90 450 270 450'/%3E%3Cpolygon fill='%23666' points='180 300 270 150 90 150'/%3E%3Cpolygon fill='%23222' points='360 300 270 450 450 450'/%3E%3Cpolygon fill='%23FFF' points='360 300 450 150 270 150'/%3E%3Cpolygon fill='%23444' points='540 300 450 450 630 450'/%3E%3Cpolygon fill='%23222' points='540 300 630 150 450 150'/%3E%3Cpolygon fill='%23AAA' points='720 300 630 450 810 450'/%3E%3Cpolygon fill='%23666' points='720 300 810 150 630 150'/%3E%3Cpolygon fill='%23FFF' points='900 300 810 450 990 450'/%3E%3Cpolygon fill='%23999' points='900 300 990 150 810 150'/%3E%3Cpolygon points='0 600 -90 750 90 750'/%3E%3Cpolygon fill='%23666' points='0 600 90 450 -90 450'/%3E%3Cpolygon fill='%23AAA' points='180 600 90 750 270 750'/%3E%3Cpolygon fill='%23444' points='180 600 270 450 90 450'/%3E%3Cpolygon fill='%23444' points='360 600 270 750 450 750'/%3E%3Cpolygon fill='%23999' points='360 600 450 450 270 450'/%3E%3Cpolygon fill='%23666' points='540 600 630 450 450 450'/%3E%3Cpolygon fill='%23222' points='720 600 630 750 810 750'/%3E%3Cpolygon fill='%23FFF' points='900 600 810 750 990 750'/%3E%3Cpolygon fill='%23222' points='900 600 990 450 810 450'/%3E%3Cpolygon fill='%23DDD' points='0 900 90 750 -90 750'/%3E%3Cpolygon fill='%23444' points='180 900 270 750 90 750'/%3E%3Cpolygon fill='%23FFF' points='360 900 450 750 270 750'/%3E%3Cpolygon fill='%23AAA' points='540 900 630 750 450 750'/%3E%3Cpolygon fill='%23FFF' points='720 900 810 750 630 750'/%3E%3Cpolygon fill='%23222' points='900 900 990 750 810 750'/%3E%3Cpolygon fill='%23222' points='1080 300 990 450 1170 450'/%3E%3Cpolygon fill='%23FFF' points='1080 300 1170 150 990 150'/%3E%3Cpolygon points='1080 600 990 750 1170 750'/%3E%3Cpolygon fill='%23666' points='1080 600 1170 450 990 450'/%3E%3Cpolygon fill='%23DDD' points='1080 900 1170 750 990 750'/%3E%3C/g%3E%3C/pattern%3E%3C/defs%3E%3Crect x='0' y='0' fill='url(%23a)' width='100%25' height='100%25'/%3E%3Crect x='0' y='0' fill='url(%23b)' width='100%25' height='100%25'/%3E%3C/svg%3E");
  background-attachment: fixed;
  background-size: cover;
}
</style>
